import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center">…</div>;
  if (user && user.id) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Identifiants invalides");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white p-6">
      <form onSubmit={submit} className="w-full max-w-md border border-white/15 p-10 bg-[#111113]" data-testid="admin-login-form">
        <ShieldCheck className="w-10 h-10 text-[#93C5FD] mb-6" strokeWidth={1.4} />
        <div className="overline text-[#93C5FD] mb-3">Espace administration</div>
        <h1 className="font-serif text-3xl mb-2">AMAR SAHRAOUI</h1>
        <p className="text-sm text-white/60 mb-8">Accès réservé à l'équipe.</p>

        <label className="overline text-white/50 mb-2 block">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid={ADMIN.loginEmail}
          className="w-full bg-transparent border border-white/20 px-4 py-3 mb-4 text-white outline-none focus:border-[#93C5FD]"
        />

        <label className="overline text-white/50 mb-2 block">Mot de passe</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid={ADMIN.loginPassword}
          className="w-full bg-transparent border border-white/20 px-4 py-3 mb-6 text-white outline-none focus:border-[#93C5FD]"
        />

        {err && <div className="text-sm text-red-400 mb-4">{err}</div>}

        <button type="submit" disabled={submitting} data-testid={ADMIN.loginSubmit} className="w-full py-3.5 bg-[#1D4ED8] hover:bg-white hover:text-[#1D4ED8] transition uppercase tracking-wider text-sm font-semibold border border-[#1D4ED8]">
          {submitting ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
